import { render, staticRenderFns } from "./publish_dialog.vue?vue&type=template&id=2ca1ccbc"
import script from "./publish_dialog.vue?vue&type=script&lang=js"
export * from "./publish_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports